import { Grid, Image } from 'semantic-ui-react'
import { Text } from '../../../components/BaseComponents'
import { useEffect } from 'react'
import { useAnalyticsView } from '../../Amplitude'

export const UploadConfirmation = () => {
  const pageView = useAnalyticsView()

  useEffect(() => {
    pageView('review monthly bank statements')
  }, [pageView])

  return (
    <Grid>
      <Grid.Row style={{ paddingTop: 32 }}>
        <Grid.Column width={4}>
          <Image
            src={'https://heard-images.s3.amazonaws.com/assets/green-check.png'}
            style={{
              padding: '60px 80px',
              backgroundColor: '#E4F2E6',
              borderRadius: 8,
            }}
          />
        </Grid.Column>
        <Grid.Column width={8} style={{ marginLeft: 64 }}>
          <Text as="h2">Thanks for uploading your statements!</Text>
          <Text style={{ paddingTop: 12 }}>
            Our bookkeeping team is reviewing your documents and will reach out
            if any additional information is needed to complete your catch-up
            bookkeeping.
          </Text>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}
